import { Divider, Menu, MenuProps } from 'antd';
import React, { useEffect, useState } from 'react'
import { IConfigPageProps } from './types'
import { 
  HomeOutlined,
  FormOutlined,
  PhoneOutlined
} from '@ant-design/icons';
import Input from '../../components/UI/Input';
import {sendSystemLog, useAuth} from "../../context/AuthProvider/useAuth";

const items: MenuProps['items'] = [
  {
    label: 'Company',
    key: 'company',
    icon: <HomeOutlined />
  },
  {
    label: 'Contact',
    key: 'contact',
    icon: <FormOutlined />,
  },
  {
    label: 'Address',
    key: 'address',
    icon: <PhoneOutlined />
  },
]

function MDORExport(props: IConfigPageProps) {
  const {canEdit} = useAuth()

  const log = {
    log_type: 'visited',
    log_object: 'system configs',
    object_name: 'mdor_export'
  }

  useEffect(() => {
    sendSystemLog(log);
  }, [])

  const [current, setCurrent] = useState('company');

  const onClick: MenuProps['onClick'] = (e) => {
    setCurrent(e.key);
  };

  const mdorChildProps = {
    config: props.config,
    setConfig: props.setConfig,
  }
  
  return (
    <div className='mdor-config'>
      <Menu style={{ backgroundColor: 'transparent' }} onClick={onClick} selectedKeys={[current]} mode="horizontal" items={items} />
      <div className="mdor-config__form">
        <Divider />
        {current === 'company' && <MDORExport.company {...mdorChildProps} />}
        {current === 'contact' && <MDORExport.contact {...mdorChildProps} />}
        {current === 'address' && <MDORExport.address {...mdorChildProps} />}
      </div>
    </div>
  )
}

const CompanyForm = (props: IConfigPageProps) => {
  const {canEdit} = useAuth()
  return (
    <>
      <Input
        label="Company name"  
        value={props.config.MDOR_BUSINESS_NAME}
        onChange={(e: any) => props.setConfig(e.target.value, 'MDOR_BUSINESS_NAME')}
        disabled={!canEdit}
      />
      <Input
        label="ETIN"
        value={props.config.MDOR_ETIN}
        onChange={(e: any) => props.setConfig(e.target.value, 'MDOR_ETIN')}
        disabled={!canEdit}
      />
      <Input
        label="FEIN"
        value={props.config.MDOR_FEIN}
        onChange={(e: any) => props.setConfig(e.target.value, 'MDOR_FEIN')}
        disabled={!canEdit}
      />
      <Input
        label="License number"  
        value={props.config.MDOR_LICENSE_NUMBER}
        onChange={(e: any) => props.setConfig(e.target.value, 'MDOR_LICENSE_NUMBER')}
        disabled={!canEdit}
      />
      <Input
        label="Permit ID"
        value={props.config.MDOR_PERMIT_ID}
        onChange={(e: any) => props.setConfig(e.target.value, 'MDOR_PERMIT_ID')}
        disabled={!canEdit}
      />
      <Input
        label="MFG ID"
        value={props.config.MDOR_MFG_ID}
        onChange={(e: any) => props.setConfig(e.target.value, 'MDOR_MFG_ID')}
        disabled={!canEdit}
      />
    </>
  )
}

const ContactForm = (props: IConfigPageProps) => {
  const {canEdit} = useAuth()
  return (
    <>
      <Input
        label="Contact first name"  
        value={props.config.MDOR_CONTACT_FIRSTNAME}
        onChange={(e: any) => props.setConfig(e.target.value, 'MDOR_CONTACT_FIRSTNAME')}
        disabled={!canEdit}
      />
      <Input
        label="Contact last name"  
        value={props.config.MDOR_CONTACT_LASTNAME}
        onChange={(e: any) => props.setConfig(e.target.value, 'MDOR_CONTACT_LASTNAME')}
        disabled={!canEdit}
      />
      <Input
        label="Contact title"  
        value={props.config.MDOR_CONTACT_TITLE}
        onChange={(e: any) => props.setConfig(e.target.value, 'MDOR_CONTACT_TITLE')}
        disabled={!canEdit}
      />
      <Input
        label="Contact phone"  
        value={props.config.MDOR_CONTACT_PHONE}
        onChange={(e: any) => props.setConfig(e.target.value, 'MDOR_CONTACT_PHONE')}
        disabled={!canEdit}
      />
      <Input
        label="Contact fax"  
        value={props.config.MDOR_CONTACT_FAX}
        onChange={(e: any) => props.setConfig(e.target.value, 'MDOR_CONTACT_FAX')}
        disabled={!canEdit}
      />
      <Input
        label="Email"  
        value={props.config.MDOR_EMAIL}
        onChange={(e: any) => props.setConfig(e.target.value, 'MDOR_EMAIL')}
        disabled={!canEdit}
      />
    </>
  )
}

const AddressForm = (props: IConfigPageProps) => {
  const {canEdit} = useAuth()
  return (
    <>
      <Input
        label="Address line 1"  
        value={props.config.MDOR_ADDRESS_LINE_1}
        onChange={(e: any) => props.setConfig(e.target.value, 'MDOR_ADDRESS_LINE_1')}
        disabled={!canEdit}
      />
      <Input
        label="Address line 2"  
        value={props.config.MDOR_ADDRESS_LINE_2}
        onChange={(e: any) => props.setConfig(e.target.value, 'MDOR_ADDRESS_LINE_2')}
        disabled={!canEdit}
      />
      <Input
        label="City"  
        value={props.config.MDOR_CITY}
        onChange={(e: any) => props.setConfig(e.target.value, 'MDOR_CITY')}
        disabled={!canEdit}
      />
      <Input
        label="State"  
        value={props.config.MDOR_STATE}
        onChange={(e: any) => props.setConfig(e.target.value, 'MDOR_STATE')}
        disabled={!canEdit}
      />
      <Input
        label="Zipcode"  
        value={props.config.MDOR_ZIPCODE}
        onChange={(e: any) => props.setConfig(e.target.value, 'MDOR_ZIPCODE')}
        disabled={!canEdit}
      />
    </>
  )
}

MDORExport.contact = ContactForm
MDORExport.company = CompanyForm
MDORExport.address = AddressForm
export default MDORExport